import EditRecipeItem from 'containers/recipes/components/editRecipeItem'
import { useGetSingleRecipeQuery, useSortRecipeIngredientsMutation } from 'containers/recipes/queries'
import { RecipeItem } from 'containers/recipes/types'
import { useParams } from 'react-router-dom'
import { forceConsistentlySteppedSortOrder, reorderOnDrag, sortBySortOrderThenAlpha } from 'utils/functions'

export function CurrentIngredients() {
    const { recipeId } = useParams()

    const { data: singleRecipeData } = useGetSingleRecipeQuery(recipeId ?? '')
    const { mutate: sortRecipeIngredients } = useSortRecipeIngredientsMutation()

    const { items: maybeItems } = singleRecipeData ?? {}
    const items = maybeItems ?? []

    const itemGroupNames = [
        ...new Set(
            items.reduce((acc: string[], curr) => {
                const group = curr.item_group
                return group ? [...acc, group] : acc
            }, [])
        )
    ]

    const itemGroups = itemGroupNames.map((groupName) => {
        return {
            name: groupName,
            items: items.filter((item) => item.item_group === groupName).sort(sortBySortOrderThenAlpha)
        }
    })

    const restItems = items.filter((item) => !item.item_group).sort(sortBySortOrderThenAlpha)

    function doSorting(itemsListBeingSorted: RecipeItem[], recipeItemIdBeingSorted: number, direction: 'up' | 'down') {
        const startingSortOrder = itemsListBeingSorted.map((ri) => ({
            recipe_item_id: ri.recipe_item_id,
            sort_order: ri.sort_order
        }))

        const forcedStartingSortOrder = forceConsistentlySteppedSortOrder(startingSortOrder)
        const itemCurrentSortOrder = forcedStartingSortOrder.find((ri) => ri.recipe_item_id === recipeItemIdBeingSorted)?.sort_order ?? 100
        const itemNewSortOrder = itemCurrentSortOrder + (direction === 'up' ? -1 : 1)
        const newSortOrders = reorderOnDrag(forcedStartingSortOrder, recipeItemIdBeingSorted, itemNewSortOrder)

        sortRecipeIngredients({
            recipeId: recipeId ?? '',
            attributes: {
                sort_orders: newSortOrders
            }
        })
    }

    return (
        <div className='overflow-hidden'>
            <ul>
                {[...restItems].map((item, index) => (
                    <EditRecipeItem
                        key={index}
                        item={item}
                        recipeId={Number(recipeId ?? '')}
                        onSortUp={() => {
                            doSorting(restItems, item.recipe_item_id, 'up')
                        }}
                        onSortDown={() => {
                            doSorting(restItems, item.recipe_item_id, 'down')
                        }}
                    />
                ))}
            </ul>
            {itemGroups.map((group) => {
                return (
                    <div key={group.name} className='mt-4'>
                        <h5 className='text-[17px]'>{group.name}</h5>
                        <ul className='pl-4'>
                            {[...group.items].map((item, index) => (
                                <EditRecipeItem
                                    key={index}
                                    item={item}
                                    recipeId={Number(recipeId ?? '')}
                                    onSortUp={() => {
                                        doSorting(group.items, item.recipe_item_id, 'up')
                                    }}
                                    onSortDown={() => {
                                        doSorting(group.items, item.recipe_item_id, 'down')
                                    }}
                                />
                            ))}
                        </ul>
                    </div>
                )
            })}
        </div>
    )
}
